import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import CloudIcon from '@material-ui/icons/Cloud';
import { rootRouteRef } from './routes';

const kubernetesOverviewPage = PageBlueprint.make({
  params: {
    routeRef: rootRouteRef,
    path: '/kubernetes',
    title: 'Kubernetes',
    icon: <CloudIcon />,
    loader: () =>
      import('./KubernetesOverviewPage').then(m => (
        <m.KubernetesOverviewPage />
      )),
  },
});

export const kubernetesOverviewPlugin = createFrontendPlugin({
  pluginId: 'kubernetes-overview',
  extensions: [kubernetesOverviewPage],
  routes: {
    root: rootRouteRef,
  },
});
